import React, {useReducer} from 'react'
import { StateInterface } from '../interface'

interface ActionInterface {
  type: 'LOGIN' | 'LOGOUT'
  payload: StateInterface
}

export const ContextProvider = React.createContext<StateInterface | {} > ({})

const reducerFunction = (state:StateInterface, action: ActionInterface ) => {
  switch(action.type){
    case "LOGIN":
      return {...state, ...action.payload}
    case "LOGOUT":
      localStorage.removeItem('token')
      return {...state, email: null, token: null}
    default:
      return state
  }
}

const Context:React.FC<React.PropsWithChildren> = ({children}) => {

  const [state, dispatch] = useReducer<any>(reducerFunction,{
    _id: null,
     name: "",
     userName:"",
     email:"",
     token: null
  })

  return (
    <ContextProvider.Provider value={{state, dispatch}}>
      {children}
    </ContextProvider.Provider>
  )
}

export default Context